module.exports = __webpack_public_path__ + "media/public/img/landing_page/headout-1-209f018df11af6b88981ce63f1a29111.png";